import React from 'react'

interface WorkMetadataFieldProps {
    title: string
    value: string | undefined | null
    default?: string
    error?: string
}

const WorkMetadataField = (props: WorkMetadataFieldProps) => (
    <div className="work-metadata-field">
        <span>{props.title}</span>
        <span>{props.value || props.default || '--'}</span>
        {props.error && <span className="error-field">{props.error}</span>}
    </div>
)

export default WorkMetadataField
